import { z } from 'zod';
export const AgenticPlatformFunctionCallSchema = z.object({
    arguments: z.string(),
    name: z.string(),
});
export const AgenticPlatformToolCallSchema = z.object({
    function: AgenticPlatformFunctionCallSchema,
    id: z.string(),
    type: z.literal('function'),
});
/** When the message was recorded. Absent on a history written before the field existed. */
const messageTimestampSchema = z.iso.datetime().optional();
export const AgenticPlatformDeveloperMessageSchema = z.object({
    content: z.string(),
    id: z.string(),
    name: z.string().optional(),
    role: z.literal('developer'),
    timestamp: messageTimestampSchema,
});
export const AgenticPlatformSystemMessageSchema = z.object({
    content: z.string(),
    id: z.string(),
    name: z.string().optional(),
    role: z.literal('system'),
    timestamp: messageTimestampSchema,
});
export const AgenticPlatformAssistantMessageSchema = z.object({
    content: z.string().optional(),
    id: z.string(),
    name: z.string().optional(),
    role: z.literal('assistant'),
    timestamp: messageTimestampSchema,
    toolCalls: z.array(AgenticPlatformToolCallSchema).optional(),
});
/**
 * One part of a structured user message.
 *
 * The protocol lets a user message carry images, audio, video, documents and raw binary
 * alongside text. The platform prompts with text alone, so the other kinds are accepted here and
 * refused by the run with a protocol error, rather than failing the request as malformed.
 */
export const AgenticPlatformUserMessageContentPartSchema = z.looseObject({
    text: z.string().optional(),
    type: z.string(),
});
export const AgenticPlatformUserMessageSchema = z.object({
    content: z.union([z.string(), z.array(AgenticPlatformUserMessageContentPartSchema)]),
    id: z.string(),
    name: z.string().optional(),
    role: z.literal('user'),
    timestamp: messageTimestampSchema,
});
export const AgenticPlatformToolMessageSchema = z.object({
    content: z.string(),
    error: z.string().optional(),
    id: z.string(),
    role: z.literal('tool'),
    timestamp: messageTimestampSchema,
    toolCallId: z.string(),
});
/**
 * A frontend-rendered activity entry, such as a progress indicator.
 *
 * The platform never produces these, but they are part of a client's history and rejecting them
 * would fail the whole run.
 */
export const AgenticPlatformActivityMessageSchema = z.object({
    activityType: z.string(),
    content: z.record(z.string(), z.json()),
    id: z.string(),
    role: z.literal('activity'),
    timestamp: messageTimestampSchema,
});
export const AgenticPlatformMessageSchema = z.discriminatedUnion('role', [
    AgenticPlatformActivityMessageSchema,
    AgenticPlatformDeveloperMessageSchema,
    AgenticPlatformSystemMessageSchema,
    AgenticPlatformAssistantMessageSchema,
    AgenticPlatformUserMessageSchema,
    AgenticPlatformToolMessageSchema,
]);
//# sourceMappingURL=message.js.map